<div wms-split-panel split="vertical" showdividers="true" class="split-panel vertical">
  <div wms-split-pane limit="210" class="resources-pane split-pane" [ngClass]="{'hide-resource-panel': pageWsService.hideResources}">
    <div class="wm-workspace-left-panel" ng-controller="wmTreeController">
      <!-- Pages -->
      <div class="wm-workspace-left-panel-content">
        <div class="editor-tools">
          <div class="components">
            <ng-container *ngIf="pageWsService.pageSubCategory === 'BUILD'">
              <div class="panel-group widget-group">
             <tabset  class="tabs-container" >
              <ng-container *ngFor="let group of widgetFactory; index as $index;">
               <tab class="accordion-panel-default panel-body" *ngIf="group.name === 'prefabs' || group.name === 'widgets'"
                    [heading]="locale[group.namekey]"
                    [active]="group.open"
                    (selectTab)="group.open = true"
                    (deselect)="group.open = false"
                    [disabled]="group.disabled">
                    <span *ngIf="group.name === 'prefabs'" class="float-right category-actions page-prefab-actions">
                      <i class="wms wms-refresh" [ngClass]="{'disabled': widgetFactory[1].searchKey || !prefabManager.prefabsLoaded}"
                        (click)="prefabManager.loadPrefabList($event, widgetFactory[1]);"></i>
                      <i class="wms wms-add" (click)="importPrefab($event);" *ngIf="isSilo"></i>
                    </span>
                 <div class="accordion-panel-default">
                                   <!--body -->
                                   <div class="widget-list" *ngIf="group.open" id="wms-widget-panel-{{$index}}">
                                     <!-- widget-search -->
                                     <div class="wm-search-container" name="widget" *ngIf="group.namekey === 'LABEL_WIDGETS'">
                                       <wms-search  name="wm-widgets-filter"  [searchKey]="searchText" (onSearch)="filterWidget(group,$event)"></wms-search>
                                     </div>
                                     <div class="wm-search-container" *ngIf="group.namekey === 'LABEL_PREFABS'" >
                                       <wms-search  name="wm-widgets-filter" [searchKey]="searchTextPre"  (onSearch)="filterPrefab(group,$event)"></wms-search>
                                     </div>

                                     <!-- widget-list  -->

                                     <div class="wm-widgets-panel-container">
                                       <div class="empty-message" *ngIf="!group.subGroups.length">{{locale[group.emptymessage]}}</div>
                                       <div class="sub-group" *ngFor="let subgroup of group.subGroups; index as $index;"
                                         [hidden]="subgroup.hide ||subgroup.filteredWidgets?.length == 0">
                                         <wms-spinner *ngIf="group.name === 'prefabs' && prefabManager.loadingComponents === group.name"
                                                      name="component-load-spinner" size="md"></wms-spinner>
                                         <label class="widget-subgroup-name">{{locale[subgroup.namekey] || subgroup.name}}</label>
                                         <ol>
                                           <ng-container *ngFor="let widget of subgroup.filteredWidgets; let j=index;">
                                             <li [attr.name]="'wm-widget-' + widget.name.replace(' ', '-').toLowerCase()" class="widget"
                                               draggable="{{preferences?.project?.pages.edit}}" [attr.data-widget-type]="widget.widgetType"
                                               [attr.data-widget-defaults]="widget._defaults"
                                               [attr.data-widget-drop-effect]="widget.dropEffectCls" wmsDraggable id="property-{{widget.name}}"
                                               *wmsFeature="getPreference(widget.feature)" wmsWidgetHelp [activeWidget]="widget"
                                               title="{{group.name === 'prefabs' ? (widget.displayName || widget.name) : (widget.isAdvanced ? widget.name : (locale[widget.namekey] || widget.name))}}">
                                               <span *ngIf="group.name === 'prefabs' && widget.isDevPrefab" class="badge prefab-status dev"><i class="wms wms-flask" title="{{locale.MESSAGE_ARTIFACT_NOT_PUBLISHED}}"></i></span>
                                               <span *ngIf="group.name === 'prefabs' && widget.isProjectPrefab && !widget.isDevPrefab" class="badge prefab-status bundled"><i class="wms wms-box" title="{{locale.MESSAGE_BUNDLED_PREFAB}}"></i></span>
                                               <p *ngIf="group.name === 'prefabs'" class="prefab-version" title="V {{widget.version}}">V {{widget.version}}</p>
                                               <i *ngIf="(group.name !== 'prefabs' && group.name !== 'WmxWidgets') || !widget.iconUrl"
                                                 class="design-tool-icon wms wms-widget-{{widget.iconclass}}" [name]="widget.name"></i>
                                               <p *ngIf="group.name !== 'prefabs' && group.name !== 'WmxWidgets'" class="design-tool-name">{{widget.isAdvanced ?
                                                 widget.name : (locale[widget.namekey] || widget.name)}}</p>
                                               <i *ngIf="(group.name === 'prefabs' || group.name === 'WmxWidgets') && widget.iconUrl" class="design-tool-icon"
                                                 [ngStyle]="{backgroundImage: 'url('+ widget.iconUrl + ')', backgroundSize:'100% 100%'}"
                                                 name="{{widget.name}}"></i>
                                               <p *ngIf="group.name === 'prefabs'|| group.name === 'WmxWidgets'" class="design-tool-name">{{widget.displayName ||
                                                 widget.name}}</p>
                                             </li>
                                           </ng-container>
                                         </ol>
                                       </div>
                                     </div>
                            </div>
                 </div>

               </tab>
               </ng-container>
             </tabset>


              </div>
            </ng-container>
            <ng-container *ngIf="pageWsService.pageSubCategory === 'LIST'">
              <div class="accordion-panel-default" name="wm-pages-list" >
                                <div accordion-heading>
                                  <div class="panel-label">
                                      <span class="wm-heading">{{locale.LABEL_PAGES}}</span>
                                      <span class="float-right category-actions" id="wms-new-page-btn">
                                        <i class="wm-icon wms wms-add" (click)="createNewPage($event);"
                                          title="{{locale.LABEL_PAGES_ADD_NEW}}" *wmsFeature="preferences?.project?.pages.create"></i>
                                      </span>
                                    </div>
                                </div>
                                <div class="widget-list">
                                  <div class="wm-search-container">
                                    <wms-search (onSearch)="filterPages($event)"></wms-search>
                                  </div>
                                  <div class="wm-workspaces-tree-container">
                                    <ul name="wm-workspaces-tree" class="nav nav-pills nav-stacked item-list pages-list">
                                      <li *ngFor="let page of pages| filter:'name':pageWsService.pageSearchKey | orderBy: 'name'; let i=index"
                                        [ngClass]="{'active': pageWsService.activePageName === page.name}" class="page">
                                        <a (click)="selectPage(page.name)" title="{{page.name}}">
                                          <span class="item-icon pull-left">
                                            <i class="wm-icon wms wms-template" *ngIf="isTemplateBundleType"></i>
                                            <i class="wm-icon wms" [ngClass]="page.type === 'PAGE' ? 'wms-page' : 'wms-partial'"
                                              *ngIf="!isTemplateBundleType"></i>
                                          </span>
                                          <span class="item-name pull-left">{{page.name}}</span>
                                        </a>
                                        <ng-container *ngIf="!(page.name == MAIN_PAGE && isPrefabTemplate)">
                                          <div class="item-actions" dropdown  title="{{locale.LABEL_OPTION}}" [ngClass]="{'display-buttons':pageActionsDD[i]}" *wmsFeature="preferences.project?.pages.delete || preferences.project?.pages.edit || preferences.project?.pages.create">
                                            <button name="page-options" (click)="pageActions(i)" class="dropdown-toggle wm-icon24 wms wms-more-horiz"
                                              dropdownToggle></button>
                                            <ul class="wm-default-menu dropdown-menu-right item-action-menu dropdown-menu" *dropdownMenu>
                                              <span class="caret wms wms-caret-up"></span>
                                              <li title="{{locale.LABEL_CONFIRM_RENAME_PAGE}}"
                                                *wmsFeature="preferences.project?.pages.edit && displayRename(page.name)">
                                                <a class="dropdown-item" (click)="editPageName($event, page.name, page.type);" name="rename-page">
                                                  <i class="wm-icon wms wms-edit"></i><span class="option-name">{{locale.LABEL_RENAME}}</span>
                                                </a>
                                              </li>
                                              <li title="{{locale.LABEL_CONFIRM_DUPLICATE_PAGE}}" *wmsFeature="preferences.project?.pages.create">
                                                <a class="dropdown-item" (click)="duplicatePage($event, page.name, page.type);" name="duplicate-page">
                                                  <i class="wm-icon wms wms-clone"></i><span class="option-name">{{locale.LABEL_DUPLICATE}}</span>
                                                </a>
                                              </li>
                                              <li title="{{locale.LABEL_CONFIRM_DELETE_PAGE}}"
                                                *wmsFeature="preferences.project?.pages.delete && displayDelete(page.name)">
                                                <a class="dropdown-item" (click)="deletePage($event, page.name, page.type);" name="delete-page">
                                                  <i class="wm-icon wms wms-delete"></i><span class="option-name">{{locale.LABEL_PAGE_DELETE}}</span>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                        </ng-container>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

            </ng-container>
              <div class="accordion-panel-default wm-page-structure-tree" name="wm-widget-group-widgets-tree" [ngClass]="{'hidden': pageWsService.pageSubCategory !== 'STRUCTURE'}">
                                <div accordion-heading>
                                  <div class="panel-label">
                                      <span class="wm-heading">{{locale.LABEL_PAGE_STRUCTURE}}</span>
                                  </div>
                                </div>
                                <div class="full-height">
                                  <wms-page-structure></wms-page-structure>
                                </div>
                              </div>

<!--            <accordion class="widget-group default" [closeOthers]="true">-->

<!--              &lt;!&ndash; Page-accordion &ndash;&gt;-->
<!--              <accordion-group class="accordion-panel-default" name="wm-pages-list" [(isOpen)]="pagesGroup.open">-->
<!--                <div accordion-heading>-->
<!--                  <h4 class="panel-title">-->
<!--                    <a>-->
<!--                      <button name="wm-expand-widget-accordian-btn" class="wm-icon wms"-->
<!--                        [ngClass]="{'wms-caret-right': !pagesGroup.open, 'wms-caret-down': pagesGroup.open}"></button>-->
<!--                      <span class="wm-heading">{{locale.LABEL_PAGES}}</span>-->
<!--                      <span class="float-right category-actions" id="wms-new-page-btn">-->
<!--                        <i class="wm-icon wms wms-plus btn button-primary" (click)="createNewPage($event);"-->
<!--                          title="{{locale.LABEL_PAGES_ADD_NEW}}" *wmsFeature="preferences?.project?.pages.create"></i>-->
<!--                      </span>-->
<!--                    </a>-->
<!--                  </h4>-->
<!--                </div>-->
<!--                <div class="widget-list">-->
<!--                  <div class="wm-search-container">-->
<!--                    <wms-search (onSearch)="filterPages($event)"></wms-search>-->
<!--                  </div>-->
<!--                  <div class="wm-workspaces-tree-container">-->
<!--                    <ul name="wm-workspaces-tree" class="nav nav-pills nav-stacked item-list pages-list">-->
<!--                      <li *ngFor="let page of pages| filter:'name':pageSearchKey | orderBy: 'name'; let i=index"-->
<!--                        [ngClass]="{'active': pageWsService.activePageName === page.name}" class="page">-->
<!--                        <a (click)="selectPage(page.name)" title="{{page.name}}">-->
<!--                          <span class="item-icon pull-left">-->
<!--                            <i class="wm-icon wms wms-template" *ngIf="isTemplateBundleType"></i>-->
<!--                            <i class="wm-icon wms" [ngClass]="page.type === 'PAGE' ? 'wms-page' : 'wms-partial'"-->
<!--                              *ngIf="!isTemplateBundleType"></i>-->
<!--                          </span>-->
<!--                          <span class="item-name pull-left">{{page.name}}</span>-->
<!--                        </a>-->
<!--                        <ng-container *ngIf="!(page.name == MAIN_PAGE && isPrefabTemplate)">-->
<!--                          <div class="item-actions" dropdown container="body" title="{{locale.LABEL_OPTION}}" [ngClass]="{'display-buttons':pageActionsDD[i]}" *wmsFeature="preferences.project?.pages.delete || preferences.project?.pages.edit || preferences.project?.pages.create">-->
<!--                            <button name="page-options" (click)="pageActions(i)" class="dropdown-toggle wm-icon24 wms wms-more-horiz"-->
<!--                              dropdownToggle></button>-->
<!--                            <ul class="wm-default-menu dropdown-menu-right item-action-menu dropdown-menu" *dropdownMenu>-->
<!--                              <span class="caret wms wms-caret-up"></span>-->
<!--                              <li title="{{locale.LABEL_CONFIRM_RENAME_PAGE}}"-->
<!--                                *wmsFeature="preferences.project?.pages.edit && displayRename(page.name)">-->
<!--                                <a class="dropdown-item" (click)="editPageName($event, page.name, page.type);" name="rename-page">-->
<!--                                  <i class="wm-icon wms wms-edit"></i><span class="option-name">{{locale.LABEL_RENAME}}</span>-->
<!--                                </a>-->
<!--                              </li>-->
<!--                              <li title="{{locale.LABEL_CONFIRM_DUPLICATE_PAGE}}" *wmsFeature="preferences.project?.pages.create">-->
<!--                                <a class="dropdown-item" (click)="duplicatePage($event, page.name, page.type);" name="duplicate-page">-->
<!--                                  <i class="wm-icon wms wms-clone"></i><span class="option-name">{{locale.LABEL_DUPLICATE}}</span>-->
<!--                                </a>-->
<!--                              </li>-->
<!--                              <li title="{{locale.LABEL_CONFIRM_DELETE_PAGE}}"-->
<!--                                *wmsFeature="preferences.project?.pages.delete && displayDelete(page.name)">-->
<!--                                <a class="dropdown-item" (click)="deletePage($event, page.name, page.type);" name="delete-page">-->
<!--                                  <i class="wm-icon wms wms-delete"></i><span class="option-name">{{locale.LABEL_PAGE_DELETE}}</span>-->
<!--                                </a>-->
<!--                              </li>-->
<!--                            </ul>-->
<!--                          </div>-->
<!--                        </ng-container>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </accordion-group>-->

<!--              &lt;!&ndash; widget-accordion & prefabs-accordian &ndash;&gt;-->
<!--              <accordion-group class="accordion-panel-default" *ngFor="let group of widgetFactory; index as $index " [ngClass]="{'hidden': activeTab!== TABS.DESIGN}"-->
<!--                [(isOpen)]="group.open" name="wm-widget-group-widgets">-->
<!--                <div accordion-heading title="{{locale[group.namekey]}}">-->
<!--                  <h4 class="panel-title">-->
<!--                    <a>-->
<!--                      <button name="wm-expand-widget-accordian-btn" class="wm-icon wms"-->
<!--                        [attr.title]="locale[group.open? 'LABEL_COLLAPSE':'LABEL_EXPAND']"-->
<!--                        [ngClass]="{'wms-caret-right':!group.open,' wms-caret-down':group.open}"></button>-->
<!--                      <span class="wm-heading">{{locale[group.namekey]}}</span>-->
<!--                      <span *ngIf="group.name === 'prefabs'" class="float-right category-actions">-->
<!--                        <i class="wms wms-refresh"-->
<!--                          [ngClass]="{'disabled': group.searchKey || !prefabManager.prefabsLoaded}"-->
<!--                          (click)="prefabManager.loadPrefabList($event, group);"></i>-->
<!--                        <i class="wms wms-plus" (click)="importPrefab($event);"-->
<!--                          *ngIf="isSilo"></i>-->
<!--                      </span>-->
<!--                    </a>-->
<!--                  </h4>-->
<!--                </div>-->
<!--                &lt;!&ndash;body &ndash;&gt;-->
<!--                <div class="widget-list" *ngIf="group.open" id="wms-widget-panel-{{$index}}">-->
<!--                  &lt;!&ndash; widget-search &ndash;&gt;-->
<!--                  <div class="wm-search-container" name="widget" *ngIf="group.namekey === 'LABEL_WIDGETS'">-->
<!--                    <wms-search  name="wm-widgets-filter"  [searchKey]="searchText" (onSearch)="filterWidget(group,$event)"></wms-search>-->
<!--                  </div>-->
<!--                  <div class="wm-search-container" *ngIf="group.namekey === 'LABEL_PREFABS'" >-->
<!--                    <wms-search  name="wm-widgets-filter" [searchKey]="searchTextPre"  (onSearch)="filterPrefab(group,$event)"></wms-search>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; widget-list  &ndash;&gt;-->
<!--                  <wms-spinner *ngIf="group.name === 'prefabs' && prefabManager.loadingComponents === group.name"-->
<!--                    name="component-load-spinner" size="md"></wms-spinner>-->
<!--                  <div class="wm-widgets-panel-container">-->
<!--                    <div class="empty-message" *ngIf="!group.subGroups.length">{{locale[group.emptymessage]}}</div>-->
<!--                    <div class="sub-group" *ngFor="let subgroup of group.subGroups; index as $index;"-->
<!--                      [hidden]="subgroup.hide ||subgroup.filteredWidgets?.length == 0">-->
<!--                      <label class="widget-subgroup-name">{{locale[subgroup.namekey] || subgroup.name}}</label>-->
<!--                      <ol>-->
<!--                        <ng-container *ngFor="let widget of subgroup.filteredWidgets; let j=index;">-->
<!--                          <li [attr.name]="'wm-widget-' + widget.name.replace(' ', '-').toLowerCase()" class="widget"-->
<!--                            draggable="{{preferences?.project?.pages.edit}}" [attr.data-widget-type]="widget.widgetType"-->
<!--                            [attr.data-widget-defaults]="widget._defaults"-->
<!--                            [attr.data-widget-drop-effect]="widget.dropEffectCls" wmsDraggable id="property-{{widget.name}}"-->
<!--                            *wmsFeature="getPreference(widget.feature)" wmsWidgetHelp [activeWidget]="widget"-->
<!--                            title="{{group.name === 'prefabs' ? (widget.displayName || widget.name) : (widget.isAdvanced ? widget.name : (locale[widget.namekey] || widget.name))}}">-->
<!--                            <span *ngIf="group.name === 'prefabs' && widget.isDevPrefab" class="badge prefab-status dev"><i class="wms wms-flask" title="{{locale.MESSAGE_ARTIFACT_NOT_PUBLISHED}}"></i></span>-->
<!--                            <span *ngIf="group.name === 'prefabs' && widget.isProjectPrefab && !widget.isDevPrefab" class="badge prefab-status bundled"><i class="wms wms-box" title="{{locale.MESSAGE_BUNDLED_PREFAB}}"></i></span>-->
<!--                            <p *ngIf="group.name === 'prefabs'" class="prefab-version" title="V {{widget.version}}">V {{widget.version}}</p>-->
<!--                            <i *ngIf="(group.name !== 'prefabs' && group.name !== 'WmxWidgets') || !widget.iconUrl"-->
<!--                              class="design-tool-icon wms wms-widget-{{widget.iconclass}}" [name]="widget.name"></i>-->
<!--                            <p *ngIf="group.name !== 'prefabs' && group.name !== 'WmxWidgets'" class="design-tool-name">{{widget.isAdvanced ?-->
<!--                              widget.name : (locale[widget.namekey] || widget.name)}}</p>-->
<!--                            <i *ngIf="(group.name === 'prefabs' || group.name === 'WmxWidgets') && widget.iconUrl" class="design-tool-icon"-->
<!--                              [ngStyle]="{backgroundImage: 'url('+ widget.iconUrl + ')', backgroundSize:'100% 100%'}"-->
<!--                              name="{{widget.name}}"></i>-->
<!--                            <p *ngIf="group.name === 'prefabs'|| group.name === 'WmxWidgets'" class="design-tool-name">{{widget.displayName ||-->
<!--                              widget.name}}</p>-->
<!--                          </li>-->
<!--                        </ng-container>-->
<!--                      </ol>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </accordion-group>-->

<!--              &lt;!&ndash; Page-structure-accordion &ndash;&gt;-->
<!--              <accordion-group class="accordion-panel-default" name="wm-widget-group-widgets-tree"-->
<!--                [(isOpen)]="widgetsTreePane.open" (isOpenChange)="enablePageStructureActiveNode && pageStructureTreeInit()">-->
<!--                <div accordion-heading>-->
<!--                  <h4 class="panel-title">-->
<!--                    <a>-->
<!--                      <button name="wm-expand-widget-accordian-btn" class="wm-icon wms"-->
<!--                        [ngClass]="{' wms-caret-right': !widgetsTreePane.open, 'wms-caret-down': widgetsTreePane.open}"></button>-->
<!--                      <span class="wm-heading">{{locale.LABEL_PAGE_STRUCTURE}}</span>-->
<!--                    </a>-->
<!--                  </h4>-->
<!--                </div>-->
<!--                <div class="full-height">-->
<!--                  <wms-page-structure></wms-page-structure>-->
<!--                </div>-->
<!--              </accordion-group>-->


<!--              &lt;!&ndash; Variables-accordion &ndash;&gt;-->
<!--&lt;!&ndash;              <accordion-group class="accordion-panel-default" name="wm-widget-group-variables-tree"&ndash;&gt;-->
<!--&lt;!&ndash;                [(isOpen)]="variablesTreePane.open">&ndash;&gt;-->
<!--&lt;!&ndash;                <div accordion-heading>&ndash;&gt;-->
<!--&lt;!&ndash;                  <h4 class="panel-title">&ndash;&gt;-->
<!--&lt;!&ndash;                    <a>&ndash;&gt;-->
<!--&lt;!&ndash;                      <button name="wm-expand-widget-accordian-btn" class="wm-icon wms"&ndash;&gt;-->
<!--&lt;!&ndash;                        [ngClass]="{'wms-caret-right': !variablesTreePane.open, ' wms-caret-down': variablesTreePane.open}"></button>&ndash;&gt;-->
<!--&lt;!&ndash;                      <span class="wm-heading">{{locale.LABEL_VARIABLES}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                    </a>&ndash;&gt;-->
<!--&lt;!&ndash;                  </h4>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div class="full-height">&ndash;&gt;-->
<!--&lt;!&ndash;                  <wms-bind-variable-tree [hideChildren]="true" [variablePanel]="true"></wms-bind-variable-tree>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;              </accordion-group>&ndash;&gt;-->

<!--            </accordion>-->
            <!--uib-accordion class="widget-group default" close-others="true">
              &lt;!&ndash; Pages list &ndash;&gt;
              <div uib-accordion-group class="panel-default" ng-init="pagesGroup = {}" is-open="pagesGroup.open" name="wm-pages-list">
                <uib-accordion-heading>
                  <button name="wm-expand-widget-accordian-btn" class="wm-icon" ng-class="{'wms wms-caret-right': !pagesGroup.open, 'wms wms-caret-down': pagesGroup.open}"></button>
                  <span class="wm-heading">{{$root.isTemplateBundleType ? locale.LABEL_TEMPLATES : locale.LABEL_PAGES}}</span>
                  <span class="float-right category-actions" id="wms-new-page-btn">
                                                      <i class="wm-icon wms wms-plus btn button-primary" ng-click="createNewPage($event);" title="{{locale.LABEL_PAGES_ADD_NEW}}" wms-feature="project.pages.create"></i>
                                                  </span>
                </uib-accordion-heading>
                <div class="widget-list">
                  <div class="wm-search-container">
                    <wms-search name="wm-pages-filter"
                                model="pagesGroup.searchKey"
                                placeholder="{{locale.LABEL_SEARCH + '...'}}"
                                title="{{locale.LABEL_SEARCH_TITLE}}"></wms-search>
                  </div>
                  <div class="wm-workspaces-tree-container">
                    <ul name="wm-workspaces-tree" class="nav nav-pills nav-stacked item-list pages-list">
                      <li ng-repeat="page in pages | filter: {name: pagesGroup.searchKey} | orderBy: 'name' track by $index" ng-class="{'active': activeWS.name === page.name}" tabindex="0" class="page" >
                        <a ng-click="selectPage(page.name);" title="{{page.name}}">
                                                                  <span class="item-icon pull-left">
                                                                      <i class="wm-icon wms wms-template" ng-if=":: $root.isTemplateBundleType"></i>
                                                                      <i class="wm-icon wms " ng-class="page.type === 'PAGE' ? 'wms-page' : 'wms-partial'" ng-if=":: !$root.isTemplateBundleType"></i>
                                                                  </span>
                          <span class="item-name pull-left">{{page.name}}</span>
                        </a>
                        <div class="item-actions" uib-dropdown dropdown-append-to-body is-open="$root.pageActionsDD[$index]" ng-class="{'display-buttons':$root.pageActionsDD[$index]}"
                             title="{{locale.LABEL_OPTION}}"
                             wms-feature="project.pages.delete || project.pages.edit || project.pages.create">
                          <button name="page-options" class="dropdown-toggle wm-icon24 wms wms-more-horiz"
                                  onclick="event.stopPropagation()" uib-dropdown-toggle></button>
                          <ul class="wm-default-menu dropdown-menu-right item-action-menu" uib-dropdown-menu>
                            <span class="caret wms wms-caret-up"></span>
                            <li title="{{$root.locale.LABEL_CONFIRM_RENAME_PAGE}}" ng-if="displayRename(page.name) && !$root.isTemplateBundleType" wms-feature="project.pages.edit">
                              <a ng-click="editPageName($event, page.name, page.type);" name="rename-page">
                                <i class="wm-icon wms wms-edit"></i><span class="option-name">{{$root.locale.LABEL_RENAME}}</span>
                              </a>
                            </li>
                            <li title="{{$root.locale.LABEL_CONFIRM_DUPLICATE_PAGE}}" ng-if="displayDuplicate(page.name)" wms-feature="project.pages.create">
                              <a ng-click="duplicatePage($event, page.name, page.type);" name="duplicate-page">
                                <i class="wm-icon wms wms-clone"></i><span class="option-name">{{$root.locale.LABEL_DUPLICATE}}</span>
                              </a>
                            </li>
                            <li title="{{$root.locale.LABEL_CONFIRM_DELETE_PAGE}}" ng-if="displayDelete(page.name)" wms-feature="project.pages.delete">
                              <a ng-click="deletePage($event, page.name, page.type);" name="delete-page">
                                <i class="wm-icon wms wms-delete"></i><span class="option-name">{{$root.locale.LABEL_PAGE_DELETE}}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              &lt;!&ndash; Widgets and Prefabs List &ndash;&gt;
              <div uib-accordion-group class="panel-default"
                   ng-repeat="group in widgetFactory track by $index"
                   is-open="group.open" ng-show="!group.hide && activeWS.details.tab === 'DESIGN'"
                   name="wm-widget-group-{{group.name}}">
                <uib-accordion-heading title="{{locale[group.namekey]}}">
                  <button name="wm-expand-widget-accordian-btn" class="wm-icon" ng-attr-title="{{locale[group.open ? 'LABEL_COLLAPSE' : 'LABEL_EXPAND']}}"
                          ng-class="{'wms wms-caret-right': !group.open, 'wms wms-caret-down': group.open}" open="{{group.open}}"></button>
                  <span class="wm-heading">{{locale[group.namekey]}}</span>
                  <span ng-if="group.name === 'prefabs'" class="float-right category-actions">
                                                      <i class="wms wms-refresh" ng-class="{'disabled': searchKey || !prefabsLoaded}" ng-click="loadPrefabList($event, group);"></i>
                                                      <i class="wms wms-plus" ng-click="importPrefab($event, group);" wms-feature="workspace.prefab.import"></i>
                                                  </span>
                </uib-accordion-heading>

                <div class="widget-list" init-if="group.open" id="wms-widget-panel-{{$index}}">
                  <div class="wm-search-container">
                    &lt;!&ndash;<wms-search name="wm-widgets-filter"
                                placeholder="{{locale.LABEL_SEARCH + '...'}}" title="{{locale.LABEL_SEARCH_TITLE}}"
                                ng-init="filterWidgets(group)"
                                on-search="filterWidgets(group, val)"
                                on-clear="filterWidgets(group)"
                                model="searchKey"
                    ></wms-search>&ndash;&gt;
                  </div>
  &lt;!&ndash;                <wms-spinner ng-if="group.name === 'prefabs' && loadingComponents === group.name" name="component-load-spinner" size="md"></wms-spinner>&ndash;&gt;
                  <div class="wm-widgets-panel-container">
                    <div class="empty-message" ng-if="!group.subGroups.length">{{locale[group.emptymessage]}}</div>
                    <div class="sub-group" ng-repeat="subGroup in group.subGroups track by $index"
                         ng-hide="subGroup.hide || !subGroup.filteredWidgets.length"
                         wms-feature="{{subGroup.feature}}">
                      <label class="widget-subgroup-name" title="{{locale[(subGroup.namekey || 'LABEL_PREFABS_' + subGroup.name.toUpperCase())] || subGroup.name | capitalize}}">{{locale[(subGroup.namekey || 'LABEL_PREFABS_' + subGroup.name.toUpperCase())] || subGroup.name | capitalize}}</label>
                      <ol>
                        <li name="wm-widget-{{widget.name.replace(' ', '-').toLowerCase()}}" class="widget"
                            ng-repeat="widget in subGroup.filteredWidgets"
                            wm-draggable draggable="{{$root.preferences['project.pages.edit']}}" data-widget-type="{{widget.widgetType }}"
                            data-widget-defaults="{{widget.defaults }}"
                            data-widget-drop-effect="{{widget.dropEffectCls}}"
                            wms-feature="{{widget.feature}}"
                            wms-help-icon
                            title="{{group.name === 'prefabs' ? (widget.displayName || widget.name) : (widget.isAdvanced ? widget.name : (locale[widget.namekey] || widget.name))}}">
                          <span ng-if="group.name === 'prefabs' && widget.isDevPrefab" class="badge prefab-status dev"><i class="wms wms-flask" title="{{locale.MESSAGE_ARTIFACT_NOT_PUBLISHED}}"></i></span>
                          <span ng-if="group.name === 'prefabs' && widget.isProjectPrefab && !widget.isDevPrefab" class="badge prefab-status bundled"><i class="wms wms-box" title="{{locale.MESSAGE_BUNDLED_PREFAB}}"></i></span>
                          <p ng-if="group.name === 'prefabs'" class="prefab-version" title="V {{widget.version}}">V {{widget.version}}</p>
                          <i ng-if="group.name !== 'prefabs' || !widget.iconUrl" class="design-tool-icon wms wms-widget-{{widget.iconclass}}"
                             ng-name="{{widget.name}}"></i>
                          <p ng-if="group.name !== 'prefabs'" class="design-tool-name">{{widget.isAdvanced ? widget.name : (locale[widget.namekey] || widget.name)}}</p>
                          <i ng-if="group.name === 'prefabs' && widget.iconUrl" class="design-tool-icon"
                             ng-style="{backgroundImage: 'url('+ widget.iconUrl + ')', backgroundSize:'100% 100%'}" name="{{widget.name}}"></i>
                          <p ng-if="group.name === 'prefabs'" class="design-tool-name">{{widget.displayName || widget.name}}</p>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              &lt;!&ndash; Widgets Tree&ndash;&gt;
              <div uib-accordion-group class="panel-default" is-open="widgetsTreePane.open"
                   ng-init="widgetsTreePane.open = false"
                   ng-if="activeWS.type === 'PAGE'"
                   name="wm-widget-group-widgets-tree">

                <uib-accordion-heading>
                  <button name="wm-expand-widget-accordian-btn" class="wm-icon" ng-class="{'wms wms-caret-right': !widgetsTreePane.open, 'wms wms-caret-down': widgetsTreePane.open}"></button>
                  <span class="wm-heading">{{locale.LABEL_PAGE_STRUCTURE}}</span>
                </uib-accordion-heading>

                <div class="full-height">
                  <div class="wm-search-container">
                    <wms-search id="widget-search" name="widget-search"></wms-search>
                  </div>
                  <div class="wm-widgets-tree-container">
                    <div class="wm-tree-container views-tree">
                      <div class="wm-tree list-type-tree">
                        <div class="readonly-wrapper" ng-if="activeWS.details.tab !== 'DESIGN'"></div>
                        <div class="treecontent-warp">
                          <wm-canvas-tree class="treecontent" search-element-id="widget-search" ></wm-canvas-tree>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              &lt;!&ndash; Variables Tree&ndash;&gt;
              <div uib-accordion-group class="panel-default" is-open="variablesTreePane.open" wms-feature="project.variables.view"
                   ng-init="variablesTreePane.open = false"
                   ng-if="activeWS.type === 'PAGE'"
                   name="wm-widget-group-variables-tree">

                <uib-accordion-heading>
                  <button name="wm-expand-widget-accordian-btn" class="wm-icon" ng-class="{'wms wms-caret-right': !variablesTreePane.open, 'wms wms-caret-down': variablesTreePane.open}"></button>
                  <span class="wm-heading">{{locale.LABEL_VARIABLES}}</span>
                </uib-accordion-heading>

                <div class="full-height">
                  <div class="wm-variables-tree-container">
                    <div class="wm-tree-container views-tree">
                      <div class="wm-tree list-type-tree">
                        <div class="treecontent-warp">
                          &lt;!&ndash;<wm-studio-tree search-element-id="wm-bindvariable-filter-search"
                                          hassearch="true"
                                          data="variablesTree" restricted-search="true"
                                          nodeclick="handleVariableNodeClick"
                                          handler="variablesTreeHandler" sort-by="id"
                                          getchildren="getChildren" icontype="plus"
                                          styles="overflow:'hidden'"></wm-studio-tree>&ndash;&gt;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </uib-accordion>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="split-pane-divider" data-index="1"><span class="split-pane-resizer"></span>
    <div class="wm-split-panel-collapsible horizontal" [hidden]="true">
      <button type="button" class="expand-bottom"><i class="wms wms-arrow-drop-down"></i></button>
      <button type="button" class="expand-top"><i class="wms wms-arrow-drop-up"></i></button>
    </div>
  </div>
  <div wms-split-pane limit="600" class="file-container-pane split-pane">
    <div class="wm-file-container ng-scope">
      <div class="wm-workspace"
        [ngClass]="{'partial': pageInfo.isPartial, 'hide-editor-properties': pageWsService.hideEditorProperties}">
        <div class="workspace-header">
          <div class="wm-actions-center" *wmsFeature='!preferences.project?.pages.edit'>
            <!-- <span title="{{locale.LABEL_SCHEMA_READONLY_MODE}}" class="readonly-schema">
                <span>{{locale.LABEL_SCHEMA_READONLY_MODE}}</span>
            </span> -->
          </div>
          @if(projectUpdatesService.invalidRepoBranchInfo; as info) {
            <div class="wm-actions-center">
              <a title="{{vcsRepoType}} {{locale['LABEL_EXTERNAL_' + info]}}" class="readonly-schema highlight-danger" (click)="openDialogForInvalidRepoBranch(info)">
                <span>{{vcsRepoType}} {{locale['LABEL_EXTERNAL_' + info]}}</span>
              </a>
            </div>
          }
          <div class="wm-actions-center" *ngIf="activeTab === 'DESIGN'">
            <ul class="btn-group view-toolbar">
              <!-- <li class="btn-group dropdown" *wmsFeature="preferences.project?.variables.view" dropdown>
                <button name="wm-header-variables" class="wm-workspace-action variables-action dropdown-toggle"
                  dropdownToggle title="{{locale.LABEL_VARIABLES}}">
                  <i class="wms wms-variables"></i>{{locale.LABEL_VARIABLES}}<span class="caret wms wms-arrow-down"></span>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="wm-default-menu dropdown-menu" role="menu"
                  aria-labelledby="button-basic">
                  <li>
                    <a title="{{locale.LABEL_VARIABLES}}"
                      (click)="openDialogWithId('variableModal'); variableService.selectedVariableView='Variables'">
                      <i class="wms wms-add-variable"></i>
                      <span class="dropdown-item">{{locale.LABEL_VARIABLES}}</span>
                    </a>
                  </li>
                  <li>
                    <a title="{{locale.LABEL_ACTIONS}}"
                      (click)="openDialogWithId('variableModal'); variableService.selectedVariableView='Actions'">
                      <i class="wms wms-action-variables"></i>
                      <span class="dropdown-item">{{locale.LABEL_ACTIONS}}</span>
                    </a>
                  </li>
                </ul>
              </li> -->
              <li class="viewport-container">
                <!--          <wm-device-types delay-compile="1000"></wm-device-types>-->
              </li>
              <!-- <li title="{{locale.LABEL_NEW_WIDGET_TEMPLATE}}">
                <button name="header-action-project" class="wm-workspace-action wm-icon24 wms wms-template"
                  *ngIf="showCreateNewPage" (click)="openCreateNewPageDialog()"></button>
              </li> -->
              <!-- <ng-container *wmsFeature="preferences.project?.pages.edit"> -->
                <!-- <li class="dropdown wm-design-more-actions wm-workspace-action"
                    *ngIf="preferences.project?.themes.explorer || preferences.project?.layouts.explorer"
                  [ngClass]="{'prefab-project': isPrefabType}"  title="{{locale.LABEL_MORE}}" dropdown>
                  <button name="header-action-project" class="wm-icon24 wms wms-more-vert dropdown-toggle" dropdownToggle></button> -->
                  <!-- <ul *dropdownMenu class="wm-default-menu  dropdown-menu"> -->
                    <!-- <ng-container  *wmsFeature="preferences.project?.layouts.explorer">
                      <li class="layout-dropdown" title="{{locale.LABEL_CHANGE_LAYOUT}}"
                      *ngIf="activeTab === 'DESIGN' && !pageInfo.isPartial" (click)="openChangeLayoutDialog()">
                        <a class="wm-page-layouts {{activeLayout.id}}" name="wm-layout-dropdown">
                          <i class="wms wms-layout-icon"></i>
                          <span>{{locale.LABEL_CHANGE_LAYOUT}}</span>
                        </a>
                      </li>
                    </ng-container> -->
                  <!-- </ul> -->
                  <!--<ul class="wm-default-menu dropdown-menu-right" uib-dropdown-menu>
                  <li title="{{locale.LABEL_THEMES_VIEW}}" wms-feature="project.themes.explorer">
                    <a name="header-theme" ng-click="showThemeDialog()">
                      <i class="wms wms-themes"></i><span class="menu-name">{{locale.LABEL_THEMES}}</span>
                    </a>
                  </li>
                  <li class="layout-dropdown" title="{{locale.LABEL_CHANGE_LAYOUT}}" wms-feature="project.layouts.explorer"
                      *ngIf="activeTab === 'DESIGN' && !pageInfo.isPartial" (click)="openChangeLayoutDialog()">
                    <a class="wm-page-layouts {{activeLayout.id}}" name="wm-layout-dropdown">
                      <i class="wms wms-layout-icon"></i>
                      <span>{{locale.LABEL_CHANGE_LAYOUT}}</span>
                    </a>
                  </li>
                  <li>
                    <a ng-click="toggleConstructionLines()"
                       title="{{locale.ICONTITLE_CONST_LINE_SHOWHIDE}}">
                      <i class="wms wms-construction-line"></i>
                      <span>{{locale.ICONTITLE_CONST_LINE_SHOWHIDE}}</span>
                    </a>
                  </li>
                  <li>
                    <a ng-click="toggleDesignPanels()"
                       title="{{locale.ICONTITLE_PROPERTIES_EXPANDCOLLAPSE}}">
                      <i class="wms wms-properties-panel"></i>
                      <span>{{locale.LABEL_EXPAND_COLLAPSE_CANVAS}}</span>
                    </a>
                  </li>
                </ul>-->
                <!-- </li>
              </ng-container> -->
<!--              <li role="separator" class="divider" *wmsFeature="preferences.project?.pages.edit"></li>-->

              <!-- list of Widget layouts -->
<!--              <ng-container *wmsFeature="preferences.project?.pages.edit">-->
<!--                <li class="dropdown wm-design-more-actions wm-workspace-action"-->
<!--                  [ngClass]="{'open': pageWsService.templateMenu.visible}" *ngIf="pageWsService.layoutOptions?.length > 0"-->
<!--                  title="{{locale.LABEL_WIDGET_LAYOUT}}">-->
<!--                  {{'ok'}}-->
<!--                  <button name="header-action-project" class="wm-icon24 wms wms-template-layout"-->
<!--                    (click)="pageWsService.templateMenu.show($event)"></button>-->
<!--                  <div class="wm-default-menu dropdown-menu wm-template-list" *ngIf="pageWsService.templateMenu.visible">-->
<!--                    <ul>-->
<!--                      <li *ngFor="let layout of pageWsService.layoutOptions" class="wm-template-list-item" title="{{layout.name}}">-->
<!--                        <div class="wm-template-list-item-content" [ngClass]="{'active': layout.selected}"-->
<!--                          (click)="pageWsService.selectLayout($event, layout)">-->
<!--                          <i class="wm-template-thumbnail"-->
<!--                             [style.background-image]="'url(' + ('assets/images/layouts/' + layout.category + '/' + layout.id + '/' + layout.thumbnail | versionManager) + ')'"></i>-->
<!--                          <span class="wm-template-name">{{layout.name}}</span>-->
<!--                        </div>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </li>-->
<!--              </ng-container>-->

              <!-- list of Widget templates -->
              <!-- <ng-container *wmsFeature="preferences.project?.pages.edit">
                <li class="dropdown wm-design-more-actions wm-workspace-action"
                  [ngClass]="{'open': templateMenu.visible}" *ngIf="templateOptions.length > 0"
                  title="{{locale.LABEL_WIDGET_TEMPLATE}}">
                  {{'hii}}
                  <button name="header-action-project" class="wm-icon24 wms wms-template-layout"
                    (click)="templateMenu.show($event)"></button>
                  <div class="wm-default-menu dropdown-menu wm-template-list" *ngIf="templateMenu.visible">
                    <ul>
                      <li *ngFor="let template of templateOptions" class="wm-template-list-item"
                        title="{{template.name}}">
                        <div class="wm-template-list-item-content" [ngClass]="{'active': template.selected}"
                          (click)="selectTemplate($event, template)">
                          <i class="wm-template-thumbnail"
                            [ngStyle]="{backgroundPosition: backgroundPositions[template.id]?.backgroundPosition , backgroundSize: 'auto', backgroundImage: template.thumbnail === '' ? '' : 'url(\'' + baseURL +'services/projects/' + pageWsService.projectService.getProjectId() + '/templatebundles/' + template.bundleId + '/versions/' + template.versionId + '/files/resources/' + template.id + '/' + template.thumbnail +  '\')'}"></i>
                          <span class="wm-template-name">{{template.name}}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ng-container>
              <ng-container  *ngIf="templateOptions?.length || layoutOptions?.length">
                <li role="separator" class="divider" *wmsFeature="preferences.project?.themes.view"></li>
              </ng-container> -->

              <!-- <li  *wmsFeature="preferences?.project.pages.edit">
                <button class="toggle-hidden-items-icon fa" [ngClass]="{'fa-eye': pageWsService.showHiddenElements, 'fa-eye-slash' : !pageWsService.showHiddenElements}"
                        (click)="toggleHiddenElements()" [disabled]="!pageWsService.hiddenElementsExist"
                        title="{{locale[!pageWsService.hiddenElementsExist ? 'ICONTITLE_NO_HIDDEN_WIDGETS' : (pageWsService.showHiddenElements ? 'ICONTITLE_HIDE_HIDDENELEMENTS' : 'ICONTITLE_SHOW_HIDDENELEMENTS')]}}">
                </button>
              </li>
              <li *wmsFeature="preferences?.project.pages.edit">
                <button class="wm-workspace-action wm-icon24 wms wms-undo" (click)="undo()"
                  [disabled]="pageWsService.isUndoDisabled()" title="{{locale.ICONTITLE_WORKSPACE_UNDO}}"></button>
              </li>
              <li *wmsFeature="preferences?.project.pages.edit">
                <button class="wm-workspace-action wm-icon24 wms wms-redo" (click)="redo()"
                  [disabled]="pageWsService.isRedoDisabled()" title="{{locale.ICONTITLE_WORKSPACE_REDO}}"></button>
              </li>
              <li *wmsFeature="preferences?.project.pages.edit">
                <button class="wm-workspace-action wm-icon24 wms wms-save" name="wm-save-design-workspace"
                  title="{{locale.ICONTITLE_WORKSPACE_SAVE}}" (click)="save()"></button>
              </li> -->

              <!-- <li role="separator" class="divider" ></li> -->
              <!-- <li *wmsFeature="preferences?.project?.pages.edit" class="dropdown wm-design-more-actions wm-workspace-action" container="body"  [hidden]="isNativeMobileApplicationType"
                  [ngClass]="{'prefab-project': isPrefabType}"  title="{{locale.PAGE_ADJUSTMENTS}}" dropdown>
                  <button name="wm-zoominout-design-workspace" class="wm-workspace-action wm-icon24 wms wms-zoom-in dropdown-toggle" dropdownToggle></button>
                  <ul *dropdownMenu class="wm-default-menu devices-dropdown dropdown-menu-right dropdown-menu">
                    <ng-container>
                      <li class="layout-dropdown" *ngFor="let device of availableDevices">
                        <a (click)="onDeviceTypeChange(device)"
                           title="{{locale[device.labelKey]}}">
                          <i class="fa" [ngClass]="{'fa-check': selectedViewPort.id==device.id}"></i>
                          <span>{{locale[device.labelKey]}}</span>
                          <span class="studio-device-spec">{{device.width}}*{{device.height}}</span>
                        </a>
                      </li>
                    </ng-container>
                  </ul>
              </li> -->
              <!-- <li class="wm-design-more-actions wm-workspace-action zoombutton" container="body"  [hidden]="isNativeMobileApplicationType"
                  [ngClass]="{'prefab-project': isPrefabType}"  title="{{locale.PAGE_ADJUSTMENTS}}">
                  <button [disabled]="zoomService.zoomPercentage$.getValue() === 50" name="wm-zoominout-design-workspace" (click)= zoomService.decreaseZoom() class="wm-workspace-action wm-icon24 wms wms-remove"></button>
                  <span class="zoomvalue">{{ (zoomService.zoomPercentage$ | async) | number:'1.0-0' }}%</span>
                  <button [disabled]="zoomService.zoomPercentage$.getValue() === 120" name="wm-zoominout-design-workspace" (click)= zoomService.increaseZoom() class="wm-workspace-action wm-icon24 wms wms-plus"></button>
              </li>
              <li class="dropdown wm-design-more-actions wm-workspace-action" container="body" *ngIf="isNativeMobileApplicationType"
                  [ngClass]="{'prefab-project': isPrefabType}"  title="{{locale.PAGE_ADJUSTMENTS}}" dropdown>
                <button name="header-action-project" class="dropdown-toggle wm-icon24 wms wms-tab-mobile dropdown-toggle" dropdownToggle></button>
                <ul *dropdownMenu class="wm-default-menu dropdown-menu-right dropdown-menu">
                  <ng-container>
                    <li class="layout-dropdown" *ngFor="let device of availableDevices">
                      <a (click)="pageWsService.canvasResize(device)"
                         title="{{locale[device.labelKey]}}">
                        <i class="fa" [ngClass]="{'fa-check': pageWsService.selectedViewPort.id==device.id}"></i>
                        <span>{{locale[device.labelKey]}}</span>
                        <span class="studio-device-spec">{{device.width}}*{{device.height}}</span>
                      </a>
                    </li>
                  </ng-container>
                </ul>
              </li> -->
<!--              <li class="wm-expand-collapse-toolbar">-->
<!--                <button class="wm-expand-collapse-button" (click)="toggleToolsPanelDisplay('properties')" name="wm-toggle-properties-panel"-->
<!--                        title="{{locale[hideEditorProperties ? 'LABEL_EXPAND' : 'LABEL_COLLAPSE']}}">-->
<!--                        <i class="wm-icon12 wms" [ngClass]="{'wms-angle-double-right': !hideEditorProperties, 'wms-angle-double-left' : hideEditorProperties}"></i>-->
<!--                </button>-->
<!--              </li>-->
              <!--<li class="wm-expand-collapse-toolbar">
                <button class="wm-expand-collapse-button" ng-click="toggleToolsPanelDisplay('properties', true)" name="wm-toggle-properties-panel"
                        title="{{locale[hideEditorProperties ? 'LABEL_EXPAND' : 'LABEL_COLLAPSE']}}"><i
                  class="wm-icon12 wms" ng-class="{'wms-angle-double-right': !hideEditorProperties, 'wms-angle-double-left' : hideEditorProperties}"></i></button>
              </li>-->
            </ul>
          </div>
<!--          <div class="wm-actions-right" [ngClass]="{'wm-design-info-container': activeTab === 'DESIGN'}">-->
<!--            <ul class="btn-group active-widget-name" *ngIf="activeTab === 'DESIGN'">-->
<!--              <li>-->
<!--                &lt;!&ndash; <span class="widget-info" title="{{activeWidget?.widgetType}}: {{activeWidget?.name}}">-->
<!--                  {{activeWidget?.widgetType}}: {{activeWidget?.name}}-->
<!--                </span> &ndash;&gt;-->
<!--                <span class="widget-info"-->
<!--                      [title]="selectedWidgetsCount > 1-->
<!--                                ? 'Multi-Selection Mode'-->
<!--                                : (activeWidget ? (activeWidget.widgetType + ': ' + activeWidget.name) : '')">-->
<!--                  {{ selectedWidgetsCount > 1-->
<!--                      ? (locale?.LABEL_MULTIPLE_WIDGETS_SELECTED || 'Multi-Selection Mode')-->
<!--                      : (activeWidget?.widgetType + ': ' + activeWidget?.name) }}-->
<!--                </span>-->
<!--              </li>-->
<!--            </ul>-->
          <!-- <div class="wm-actions-right" [ngClass]="{'wm-design-info-container': activeTab === 'DESIGN'}">

            <ul class="btn-group" *ngIf="activeTab !== 'DESIGN'">
              <li class="code-editor-config dropdown" dropdown [attr.title]="locale.ICONTITLE_CODE_EDITOR_CONFIG"
                [insideClick]="true">
                <button dropdownToggle type="button" class="dropdown-toggle btn-transparent wm-workspace-action"
                  aria-controls="dropdown-basic">
                  <i class="wm-icon24 wms wms-settings"></i>
                </button>
                <ul class="list-inline wm-default-menu dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <span class="caret-up"></span>
                  <li>
                    <div>
                      <h5>Code Editor Settings</h5>
                      <ul class="wm-ui-ace-toolbar">
                        <li class="ace-toolbar-action themes">
                          <div>
                            <label class="col-md-5">Theme:</label>
                            <select class="col-md-7" id="theme" size="1" (change)="changeEditorTheme($event)">
                              <optgroup *ngFor="let group of groupThemes" [label]="group.label">
                                <option
                                  *ngFor="let theme of group.themes"
                                  [value]="theme.value"
                                  [selected]="editorOptions.theme === theme.value">
                                  {{ theme.name }}
                                </option>
                              </optgroup>
                            </select>
                          </div>
                        </li>
                        <li class="ace-toolbar-action font-size">
                          <div>
                            <label class="col-md-5">Font Size:</label>
                            <select class="col-md-7" id="fontsize" size="1" (change)="changeEditorFontSize($event)">
                              <option value="12" *ngIf="editorOptions.fontSize===12" selected>Small</option>
                              <option value="12" *ngIf="editorOptions.fontSize!==12">Small</option>
                              <option value="14" *ngIf="editorOptions.fontSize===14" selected>Medium</option>
                              <option value="14" *ngIf="editorOptions.fontSize!==14">Medium</option>
                              <option value="16" *ngIf="editorOptions.fontSize===16" selected>Large</option>
                              <option value="16" *ngIf="editorOptions.fontSize!==16">Large</option>
                              <option value="20" *ngIf="editorOptions.fontSize===20" selected>Extra Large</option>
                              <option value="20" *ngIf="editorOptions.fontSize!==20">Extra Large</option>
                            </select>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="btn-group" *ngIf="activeTab !== 'DESIGN'">
              <li>
                <button class="wm-workspace-action wm-icon24 wms wms-save" name="wm-save-design-workspace"
                  title="{{locale.ICONTITLE_WORKSPACE_SAVE}}" (click)="save()"></button>
              </li>
            </ul>
          </div> -->
        </div>

        <div class="workspace-content " [hidden]="activeTab !== 'DESIGN'">
          <wms-design-container (onUpdate)="onUpdate" [pageInfo]="activePageInfo" [isPrefabTemplate]="isPrefabTemplate">
            <ng-container>
              <router-outlet></router-outlet>
            </ng-container>
            <ng-container #dynamicComponent></ng-container>
          </wms-design-container>
        </div>
        <div class="wm-code-editor-container workspace-content editor-container"
          [hidden]="activeTab && activeTab === 'DESIGN'">
          <div class="ws-pagename"><span>{{pageWsService.activePageName+editorLanguageType}}</span> </div>
          <!--<div class="wm-code-editor" ui-ace="editorOptions" ng-model="ws.editorContent" handler="ws.editor"
               ng-controller="PageWSCodeEditorController" editor-type="{{ws.editorType}}" page-name="{{ws.pageName}}" ng-readonly="{{!$root.preferences['project.pages.edit']}}"></div>-->
          <wms-editor [options]="pageWsService.editorOptions" (onChange)="pageWsService.onEditorChange()"></wms-editor>
        </div>
      </div>
    </div>
  </div>
</div>
<wms-dialog id="variableModal" [content]="variableContent"
  customClasses="modal large wm-studio-dialog fade add-new-variable-container-dialog wm-right-panel-container" [closeOnEscape]="false">
</wms-dialog>
<ng-template #variableContent>
  <wms-variable-config [variableView]="variableService.selectedVariableView"
    (onModalClose)="closeDialogWithId('variableModal')"></wms-variable-config>
</ng-template>
<!--<ng-container #dynamicComponent></ng-container>-->

<!--Content for page name edit screen-->
<wms-dialog id="renamePageDialog" [content]="renamePageContent" customClasses="rename-page-dialog small wm-studio-dialog"></wms-dialog>
<ng-template #renamePageContent>
  <wms-rename-page (onModalClose)="closeDialogWithId('renamePageDialog')" [dialogParams]="dialogParams"></wms-rename-page>
</ng-template>



<wms-dialog id="deletePageDialog" [content]="deletePageContent">
</wms-dialog>
<ng-template #deletePageContent>
<wms-global-confirm-dialog [caption]="caption" [content]="messageContent" (onModalClose)="closeDialogWithId('deletePageDialog')" (onModalOk)="onDeletePageConfirm(deleteParams)"></wms-global-confirm-dialog>
</ng-template>

<wms-dialog id="eventsAddVariableModal" [content]="addVariableContent" customClasses="modal large wm-studio-dialog fade add-new-variable-container-dialog wm-right-panel-container">
</wms-dialog>
<ng-template #addVariableContent>
    <wms-add-variable-config [serviceTypeGroups]="variableService.serviceTypeGroups" (onModalClose)="closeDialogWithId('eventsAddVariableModal')"></wms-add-variable-config>
</ng-template>

<wms-dialog id="upgradePrefabDialog"  [content]="upgradePrefab"  customClasses="small  wm-studio-dialog" ></wms-dialog>
<ng-template #upgradePrefab>
  <wms-upgrade-prefab [prefabUpdate]="prefabManager.upgradePrefabDetails"></wms-upgrade-prefab>
</ng-template>

@for(dialog of [{
  id: 'missingRepoDialog',
  type: 'repository',
  title: locale.LABEL_EXTERNAL_REPOSITORY_NOT_FOUND,
}, {
  id: 'missingBranchDialog',
  type: 'branch',
  title: locale.LABEL_EXTERNAL_BRANCH_NOT_FOUND,
}]; track dialog.id) {
  <wms-dialog [id]="dialog.id" customClasses="small wm-studio-dialog">
    <wms-dialog-header [title]="vcsRepoType + ' ' + dialog.title" (onClose)="closeDialogWithId(dialog.id)"></wms-dialog-header>
    <wms-dialog-body>
      <div class="repo-warning">
        <div class="repo-warning-icon">
          <i class="wms wms-error-triangle"></i>
        </div>
        <div class="repo-warning-heading">
          <span class="status-message">{{vcsRepoType}} {{dialog.title}}!</span>
        </div>
        <div class="repo-warning-text">
          <span class="status-message">
            {{locale.LABEL_THE_VCS}}
            <a [href]="projectService.projectEdnDetails.extVcsUrl" target="_blank">{{vcsRepoType}} {{dialog.type}}</a>
            {{locale.LABEL_EXTERNAL_REPO_INFO}}
          </span>
        </div>
      </div>
    </wms-dialog-body>
    <wms-dialog-footer>
      <button class="button-primary btn app-button" [title]="locale.LABEL_OK" (click)="closeDialogWithId(dialog.id)">
        <span class="btn-caption">{{locale.LABEL_OK}}</span>
      </button>
    </wms-dialog-footer>
  </wms-dialog>
}

<wms-dialog id="missingCredentialsDialog" customClasses="small wm-studio-dialog user-vcs-credentials-dialog">
  <wms-dialog-header [title]="vcsRepoType + ' ' + locale.LABEL_EXTERNAL_USER_VCS_CREDENTIALS_REQUIRED" (onClose)="closeDialogWithId('missingCredentialsDialog')"></wms-dialog-header>
  <wms-dialog-body>
    <div class="repo-warning">
      <div class="repo-warning-icon repo-warning-icon-no-margin">
        <i class="wms wms-error-triangle"></i>
      </div>
      <div class="repo-warning-heading">
        <span class="status-message">{{vcsRepoType}} {{locale.LABEL_EXTERNAL_USER_VCS_CREDENTIALS_REQUIRED}}!</span>
      </div>
      <div class="app-composite-widget clearfix">
        <ul class="col-md-12 vcs-info">
          <li class="vcs-provider col-md-4">
            <div class="vcs-provider-details">
              <img [src]="getIconUrl()"/>
            </div>
          </li>
          <li class="vcs-provider col-md-4">
            <div class="vcs-provider-details">
              <p class="vcs-label">{{locale.LABEL_BASE_URL}}</p>
              <p class="vcs-value" title="{{projectService.projectEdnDetails.vcsAccountDTO.baseUrl}}">{{projectService.projectEdnDetails.vcsAccountDTO.baseUrl}}</p>
            </div>
          </li>
          <li class="vcs-provider col-md-4">
            <div class="vcs-provider-details">
              <p class="vcs-label">{{vcsGroupLabel}}</p>
              <p class="vcs-value" title="{{vcsGroupName}}">{{getGroupData()}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="repo-warning-text">
          <span class="status-message">
            {{locale.MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND1}} {{vcsRepoType}} {{locale.MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND2}}
          </span>
      </div>
      <div class="repo-warning-text">
        <span class="status-message repo-warning-text-bold">
            {{locale.MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND_CONTACT}} {{vcsRepoType}}.
          </span>
      </div>
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button class="button-primary btn app-button" [title]="locale.LABEL_OK" (click)="closeDialogWithId('missingCredentialsDialog')">
      <span class="btn-caption">{{locale.LABEL_OK}}</span>
    </button>
  </wms-dialog-footer>
</wms-dialog>

<wms-property-templates-list></wms-property-templates-list>
